import React, {useState, useEffect} from 'react'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {DataStep1} from './SettingsModel'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import axios from 'axios'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import {initialQueryState, KTIcon, useDebounce} from '../../../../_metronic/helpers'
import {CKEditor} from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import Switch from '@mui/material/Switch'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import {useLocation} from 'react-router'

const Edit = (props: any) => {
  const location = useLocation()
  const Temp: any = location.state
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const API_URL = process.env.REACT_APP_API_URL
  const IMG = process.env.REACT_APP_IMAGE_URL
  const PVL_URL = process.env.REACT_APP_PVL_URLV1
  const PVL_URL2 = process.env.REACT_APP_PVL_URLV2
  const PVL_IMG = process.env.REACT_APP_PVL_IMAGE
  const initialValues: DataStep1 = {
    title_th: '',
    title_en: '',
    content_th: '',
    content_en: '',
    type: 'CONTENT',
    order_item: 1,
    thumbnail_th: '',
    thumbnail_en: '',
    image_th: '',
    image_en: '',
    is_active: false,
  }
  const [data, setData] = useState<DataStep1>(initialValues)
  const updateData = (fieldsToUpdate: Partial<DataStep1>): void => {
    const updatedData = Object.assign(data, fieldsToUpdate)
    setData(updatedData)
  }
  const editorConfiguration = {
    // Other configuration options...
    editorConfig: {
      // Set the default text color here
      fontColor: 'red',
    },
  }
  const AlertError = (message: string) => {
    Swal.fire('', message, 'error')
  }
  const [bannertType, setBannertType] = useState([
    {name: 'CONTENT'},
    {name: 'LINK'},
    {name: 'PRIVILEGE'},
    {name: 'ANNOUNCE'},
  ])
  const [typeData, setTypeData] = useState(Temp.type)

  useEffect(
    () => {
      let data: any = location.state
      console.log(data)

      console.log(data.thumbnail_en.split('/'))
      setID(data.id)
      setTitle(data.title_th)
      setContent(data.content_th)
      setTypeData(data.type)
      setImage(data.thumbnail_en.split('/')[4])
      setActive(data.is_active)
      console.log(typeData)
    },
    [] // Only re-call effect if value or delay changes
  )

  const uploadImage = async (e: any) => {
    if (e.target.files.length) {
      //e.preventDefault()
      var _URL = window.URL || window.webkitURL
      var file = e.target.files[0]
      var formdata = new FormData()
      formdata.append('image', file)
      var requestOptions = {
        method: 'POST',
        body: formdata,
        redirect: 'follow',
      }
      const data = await axios.post(`${API_URL}/upload`, formdata)
      setImage(data.data.filename)
    }
  }

  const create = async () => {
    let temp: any = []
    /*tagData.map((item: any) => {
      console.log(item.tag_id)
      temp.push(item.tag_id)
    })*/
    Swal.fire({
      title: '',
      text: 'Confirm Edit',
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      showLoaderOnConfirm: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const data = await axios
          .put(`${API_URL}/banner/${id}`, {
            title_th: title,
            title_en: title,
            content_th: content,
            content_en: content,
            type: typeData,
            order_item: order,
            thumbnail_th: image,
            thumbnail_en: image,
            image_th: image,
            image_en: image,
            is_active: active,
          })
          .then(async (res) => {
            await Swal.fire('Success', 'Success', 'success')
            navigate(-1)
          })
          .catch((err) => {
            Swal.fire('Edit !', 'Your can not Edit. !! ' + err, 'error')
          })
      }
    })
  }

  const [text, setText] = useState<any>('')
  const [title, setTitle] = useState<any>('')
  const [id, setID] = useState<any>(0)
  const [price, setPrice] = useState<any>('')
  const [brand, setDealBrand] = useState<any>('')
  const [content, setContent] = useState<any>('')
  const [condition, setCondition] = useState<any>('')
  const [category, setCategory] = useState<any>([])
  const [image, setImage] = useState<any>('')
  const [point, setPoint] = useState<any>(0)
  const [time, setTime] = useState<any>(0)
  const [order, setOrder] = useState<any>(0)
  const [active, setActive] = useState<any>(false)

  const formik = useFormik<DataStep1>({
    initialValues,
    //validationSchema: profileDetailsSchema,
    onSubmit: (values) => {
      console.log(values)
      setLoading(true)
      setTimeout(async () => {
        //values.communications.email = data.communications.email
        //values.communications.phone = data.communications.phone
        //values.allowMarketing = data.allowMarketing
        const updatedData = Object.assign(data, values)
        setData(updatedData)
        Swal.fire({
          title: '',
          text: 'Confirm Edit',
          icon: 'info',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          showLoaderOnConfirm: true,
        }).then(async (result) => {
          if (result.isConfirmed) {
            const data0 = await axios
              .put(`${API_URL}/bo/participant/${1}`, {
                //firstname: values.fName,
                //lastname: values.lName,
                //mobile_number: values.contactPhone,
              })
              .then(async (res) => {
                await Swal.fire('Success', 'Success', 'success')
                navigate(-1)
              })
              .catch((err) => {
                Swal.fire('Edit !', 'Your can not Edit. !! ' + err, 'error')
              })
          }
        })

        setLoading(false)
      }, 1000)
    },
  })

  return (
    <div className='card mb-5 mb-xl-10'>
      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>Category</label>
              <div className='col-lg-6 fv-row'>
                <Autocomplete
                  //multiple
                  id='tags-standard'
                  options={bannertType}
                  getOptionLabel={(option) => option.name}
                  defaultValue={{name: typeData}}
                  onChange={(event: any, newValue: any | null) => {
                    if (newValue) {
                      setTypeData(newValue.name)
                    } else {
                      setTypeData('')
                    }
                    console.log(newValue)
                  }}
                  //defaultValue={[top100Films[13]]}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant='standard'
                      //label='Multiple values'
                      //placeholder='Favorites'
                    />
                  )}
                />
              </div>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>ชื่อกิจกรรม</label>
              <div className='col-lg-6 fv-row'>
                <input
                  value={title}
                  onChange={(e: any) => {
                    setTitle(e.target.value)
                  }}
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  placeholder=''
                  //{...formik.getFieldProps('deal_name')}
                />
              </div>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>รายละเอียดกิจกรรม</label>
              <div className='col-lg-6 fv-row'>
                <CKEditor
                  editor={ClassicEditor}
                  data={content}
                  config={{
                    toolbar: [
                      'heading',
                      '|',
                      'bold',
                      'italic',
                      'blockQuote',
                      'link',
                      'numberedList',
                      'bulletedList',
                      'imageUpload',
                      'insertTable',
                      'tableColumn',
                      'tableRow',
                      'mergeTableCells',
                      'mediaEmbed',
                      '|',
                      'undo',
                      'redo',
                    ],
                  }}
                  onReady={(editor) => {
                    // You can store the "editor" and use when it is needed.
                    console.log('Editor is ready to use!', editor)
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData()
                    setContent(editor.getData())
                    console.log(text)
                  }}
                  onBlur={(event, editor) => {
                    console.log('Blur.', editor)
                  }}
                  onFocus={(event, editor) => {
                    console.log('Focus.', editor)
                  }}
                />
              </div>
            </div>

            <div className='row mb-6'>
              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                  <span>Image</span>
                </label>

                <div className='col-lg-6 fv-row'>
                  <input
                    value={image}
                    type='text'
                    className='inputIMG form-control form-control-lg form-control-solid'
                    placeholder=''
                  />
                </div>
                <div className='col-lg-2 fv-row'>
                  <span className='btn btn-primary btn-file wbt editbtn'>
                    Add
                    <input
                      //disabled={loading}
                      type='file'
                      accept='.jpg,.png,jpeg'
                      onChange={uploadImage}
                    />
                  </span>
                </div>
              </div>
              {image != '' && (
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>
                    <span></span>
                  </label>
                  <div className='wbt editbtn'>
                    <img style={{width: '400px'}} src={`${IMG}/${image}`} />
                  </div>
                </div>
              )}
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>ลำดับการแสดง</label>
              <div className='col-lg-6 fv-row'>
                <input
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  placeholder=''
                  value={order}
                  onChange={(e: any) => {
                    setOrder(e.target.value)
                  }}
                />
              </div>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>เปิดใช้งาน</label>
              <div className='col-lg-6 fv-row'>
                <Switch
                  checked={active}
                  onChange={(e: any) => {
                    setActive(e.target.checked)
                  }}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
      <div className='card-footer d-flex justify-content-end py-6 px-9'>
        <button
          //type='submit'
          className='btn btn-primary'
          disabled={loading}
          onClick={async () => {
            await create()
          }}
        >
          {!loading && 'Save'}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...{' '}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
    </div>
  )
}

export {Edit}
